import React, { useState,ReactNode,useEffect,useCallback } from 'react';
import Select from 'react-select';
import EarnIcn from "../styles/webroot/images/earned-icn.png";
import PaidIcn from "../styles/webroot/images/paid-icn.png";
import CallIcn from "../styles/webroot/images/call-icn.png";
import MailIcn from "../styles/webroot/images/mail-icn.png";
import UploadError from "../styles/webroot/images/upload-error.png";
import { useDispatch,useSelector } from 'react-redux'
import { getDashboardCount,getDashboardGraphData,getPendingPayment } from '@src/store/slices/common';
import FullPageLoader from '@src/common/FullPageLoader';
import { VictoryChart, VictoryBar, VictoryGroup, VictoryAxis,VictoryTooltip,VictoryLegend } from "victory";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { getMasterConfig } from '@src/store/slices/insurance';
import {LEAD_LIST_FILTER, STATUS_CODES, COUNTRY_CODE} from '@src/config/constant';
import secureStorage from "@src/config/encrypt";
import * as HELPER from "@src/config/helper";
import DashboardFilterPopup from '@src/common/DashboardFilterPopup';
import CardIcn1 from "../styles/webroot/images/card_in_1.png"
import CardIcn2 from "../styles/webroot/images/card_in_2.png"
import CardIcn3 from "../styles/webroot/images/card_in_3.png"
import CardIcn4 from "../styles/webroot/images/card_in_4.png"
import {leadListFilters} from '@src/store/slices/insurance';
import DashboardID from './DashboardID'

type CustomDateRange = {
  taskSummaryFilters: { from_date: string; to_date: string };
  pendingPaymentFilters: { from_date: string; to_date: string };
  raised_soa?: any; 
};

const graphOption = [
  { value: 'month', label: 'Month View' },
  { value: 'quater', label: 'Quarter View' },
];

interface BucketData {
  label: string;
  count: number;
  type: string;
  screenTitle: string;
  pending_amount?: number;
  amountTitle?: string; //
}

interface EarningSummary {
  comission_earned: string;
  comisssion_paid: string;
}

interface PendingPayment {
  label: string;
  count: number;
  type: string;
  screenTitle: string;
  pending_amount: number;
  amountTitle: string;
}

interface ApiResponse {
  bucket_data: BucketData[];
  earning_summary: EarningSummary;
  pending_payment: PendingPayment;
}

interface GraphData {
  month: string;
  year: string;
  policySold: number;
  actualEarning: number;
  data: { color: string; label: string }[];
}

interface GraphApiResponse {
  average_policy_sold: number;
  average_actual_earning: number;
  graphData: GraphData[];
}

interface SoaOption {
  label: string;
  value: string | number; // If value can be a string or number, adjust accordingly
}

const Dashboard = (props: any) => {
  const isCountryId = COUNTRY_CODE ==='id' ? true : false;

  const navigate = useNavigate();
  const [data, setData] = useState<ApiResponse | null>(null);
  const [pendingPayment, setPendingPayment] = useState<PendingPayment | null>(null);
  let [loading, setLoading] = useState<boolean>(false)
  const [isCreateAccess , setIsCreateAccess] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    graphFilter: {
      label: graphOption[0].label,
      value: graphOption[0].value,
    },
    taskSummaryFilters: {
      label: LEAD_LIST_FILTER.taskSummaryFilters[1].label,
      value: LEAD_LIST_FILTER.taskSummaryFilters[1].value,
    },
    pendingPaymentFilters: {
      label: LEAD_LIST_FILTER.pendingPaymentFilters[0].label,
      value: LEAD_LIST_FILTER.pendingPaymentFilters[0].value,
    },
    raised_soa: null
  });
  const [customDateRange, setCustomDateRange] = useState<CustomDateRange>({
    taskSummaryFilters: { from_date: '', to_date: '' },
    pendingPaymentFilters: { from_date: '', to_date: '' },
  });
 
  const [raised_soa, setRaisedSoa] = useState<SoaOption | null>();
  const [searchKey, setSearchKey] = useState('');
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const dispatch: any = useDispatch();
  const [graphData, setGraphData] = useState<GraphApiResponse>({
    average_policy_sold: 0,
    average_actual_earning: 0,
    graphData: [],
  });

  const [filterList, setFilterList] = useState<any>({});
  const [filterType, setFilterType] = useState('');
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const commonState = useSelector((state: any) => state.common);
  const [masterConfig, setMasterConfig] = useState<any>({});

  const fetchMasterConfig = useCallback(async () => {
    try {
      const res: any = await dispatch(getMasterConfig());
      if (res) {
        setMasterConfig(res);
      }
    } catch (error) {
      console.error("Failed to fetch master config:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!commonState?.common || Object.keys(commonState.common).length === 0) {
      fetchMasterConfig();
    } else {
      setMasterConfig(commonState.common);
    }
    dispatch(leadListFilters({}))
  }, [commonState?.common, fetchMasterConfig]);
 
  const DashboardCount = (dashBoardCountRequest: any = {}) => {
    setLoading(true);
    const currentDate = new Date();
    let from_date = '';
    let to_date = '';
    if (Object.keys(dashBoardCountRequest).length === 0) {
      const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      // If no dates are provided in the request, set default for MTD (Month To Date)
      from_date = firstDayOfMonth.toLocaleDateString('en-CA'); // First day of the current month
      to_date = currentDate.toISOString().split('T')[0]; // Today's date
    } else {
      from_date = dashBoardCountRequest.from_date || '';
      to_date = dashBoardCountRequest.to_date || '';
    }
    const requestPayload = {
      ...dashBoardCountRequest,
    };
    if (from_date) requestPayload.from_date = from_date;
    if (to_date) requestPayload.to_date = to_date;
    
    if(!isCountryId){
    dispatch(getDashboardCount(requestPayload)).then((res: any) => {
        setLoading(false)
        if (res && res.status === STATUS_CODES['success']) {
          setData(res.data);
        }
    }).catch((err: Error) => {
        setLoading(false)
    })
  }
  }

  const PendingPaymentCount = (pendingCountRequest: any = {}) => {
    setLoading(true);
    const currentDate = new Date();
    let from_date = '';
    let to_date = '';
    if (Object.keys(pendingCountRequest).length === 0) {
      let currentNewDate = new Date(currentDate); 
      currentNewDate.setDate(currentDate.getDate() + 1);
      from_date = currentNewDate.toISOString().split('T')[0];
      const next7Days = new Date(currentDate);
      next7Days.setDate(currentDate.getDate() + 7);
      to_date = next7Days.toISOString().split('T')[0];
    }else{
      from_date = pendingCountRequest.from_date || '';
      to_date = pendingCountRequest.to_date || '';
    }
    const requestPayload = {
      ...pendingCountRequest
    };
    if (from_date) requestPayload.from_date = from_date;
    if (to_date) requestPayload.to_date = to_date;
    if(pendingCountRequest.raised_soa) requestPayload.raised_soa = pendingCountRequest.raised_soa;
    if(!COUNTRY_CODE){
    dispatch(getPendingPayment(requestPayload)).then((res: any) => {
        setLoading(false)
        if (res && res.status === STATUS_CODES['success']) {
          setPendingPayment(res.data);
        }
    }).catch((err: Error) => {
        setLoading(false)
    })
  }

  }

  const GraphData = (graphRequest: any) => {
    setLoading(true);
    try{
      if(!COUNTRY_CODE){
      getDashboardGraphData(graphRequest).then((res:any) => {
        setLoading(false)
        if (res && res.data) {
          setGraphData(res.data);
        }
      });
    }
    }catch(error){
      setLoading(false)
    }
    
  }


  useEffect(() => {
    DashboardCount();
    PendingPaymentCount();
    // eslint-disable-next-line
  } , [])

  useEffect(() => {
    const graphRequest = {
      view_type: selectedOption?.graphFilter?.value || "month"
    }
    GraphData(graphRequest);
  }, [selectedOption.graphFilter]);


  const handleFilterPopup = (filters:any, key:string) => {
    setFilterList(filters);
    setFilterType(key);
    setShowFilterPopup(true);
  }

  const handleFilterPopupClose = () => {
    setShowFilterPopup(false)
  } ;

  const getFilterOption = (type: keyof typeof LEAD_LIST_FILTER, value: string | number) => {
    const filterOptions = LEAD_LIST_FILTER[type];
    return filterOptions?.find((option) => option.value.toString() === value.toString()) || null;
  };

  const applyFilter = (filter:any) => {
    const selectedFilterValue = filter[filterType];
    const updatedOption = getFilterOption(filterType as keyof typeof LEAD_LIST_FILTER, selectedFilterValue);
    if (updatedOption) {
      setSelectedOption((prev) => ({
          ...prev,
          [filterType]: {
              label: updatedOption.label,
              value: updatedOption.value,
          },
      }));
    }
    if ('raised_soa' in filter) {
      const selectedSoa = LEAD_LIST_FILTER.raised_soa.find(option => option.value === filter.raised_soa.toString());
      if (selectedSoa) {
          setRaisedSoa(selectedSoa);
      }
    }
    const filterDates = selectedFilterValue === "cdr"
    ? {
          from_date: filter.from_date || null,
          to_date: filter.to_date || null,
      }
    : HELPER.dateReturn(selectedFilterValue) || { from_date: null, to_date: null };

    if (selectedFilterValue === "cdr") {
      setCustomDateRange((prevState) => ({
          ...prevState,
          [filterType]: {
              from_date: filter.from_date || '',
              to_date: filter.to_date || '',
          },
      }));
    }

    let finalFilter = {
      ...filter,
      ...filterDates,
    };

    const { [filterType]: _, ...rest } = finalFilter;
    finalFilter = rest;

    Object.keys(finalFilter).forEach((key) => {
        if (finalFilter[key] === null || finalFilter[key] === "") {
            delete finalFilter[key];
        }
    });
    if(filterType === "taskSummaryFilters"){
      DashboardCount(finalFilter);
    }else{
      PendingPaymentCount(finalFilter);
    }
  }
  
  const setSearchKeyword = (keyword:any) => {
    setSearchKey(keyword);
  }

  const handleKeyDown = (event:any) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = () => {
    let resultWithSearchKey: any = {
      searchKey,
    };
    if (selectedOption.taskSummaryFilters?.value === "cdr") {
      const customRange = customDateRange['taskSummaryFilters'];
      resultWithSearchKey = {
        ...customRange,
        ...resultWithSearchKey,
        datetype: selectedOption.taskSummaryFilters.value,
      };
    }else{
      resultWithSearchKey = {
        searchKey,
        datetype: selectedOption.taskSummaryFilters.value,
      };
    }
    const queryString = new URLSearchParams(resultWithSearchKey).toString();
    navigate(`/insurance-list?${queryString}`);
  }

  const handleRedirection = (redirectType:string) => {
    let redirectionParams = {};
    if(redirectType === data?.bucket_data[0].type || redirectType === data?.bucket_data[1].type || redirectType === data?.bucket_data[2].type){
      if (selectedOption.taskSummaryFilters?.value === "cdr") {
        const getFilterData = customDateRange['taskSummaryFilters'];
        if(searchKey) redirectionParams = { ...getFilterData, searchKey,datetype: selectedOption.taskSummaryFilters.value, };
        else redirectionParams = { ...getFilterData,datetype: selectedOption.taskSummaryFilters.value, };
      }else{
        if(searchKey) redirectionParams = { searchKey,datetype: selectedOption.taskSummaryFilters.value, };
        else redirectionParams = { datetype: selectedOption.taskSummaryFilters.value, };
      }
    }else{

      if (selectedOption.pendingPaymentFilters?.value === "cdr") {
        const getFilterData = customDateRange['pendingPaymentFilters'];
        redirectionParams = { ...getFilterData,datetype: selectedOption.pendingPaymentFilters.value };
        if(searchKey) redirectionParams = { ...redirectionParams, searchKey };
        if(raised_soa) redirectionParams = { ...redirectionParams, raised_soa: raised_soa.value};
      }else{
        redirectionParams = { datetype: selectedOption.pendingPaymentFilters.value };
        if(searchKey) redirectionParams = { ...redirectionParams, searchKey };
        if(raised_soa) redirectionParams = { ...redirectionParams, raised_soa: raised_soa.value};
      }
    }
    redirectionParams = {...redirectionParams, status_type : redirectType}
    const queryString = new URLSearchParams(redirectionParams).toString();
    navigate(`/insurance-list?${queryString}`);
  }

  const handleGraphViewChange = (selectedOption: any) => {
    setSelectedOption((prev) => ({
      ...prev,
      graphFilter: {
        label: selectedOption.label,
        value: selectedOption.value,
      },
    }));
    const graphRequest = {
      view_type: selectedOption?.value || "month"
    }
    GraphData(graphRequest);
  };

  const hideErrorPopup = () => {
    setError(false);
    document.body.classList.remove("overflow-hidden");
  };

  const hideSuccessPopup = () => {
    setSuccess(false);
    document.body.classList.remove("overflow-hidden");
  };

  const transformedData = graphData.graphData.map((item) => ({
    x: `${item.month} ${item.year}`,
    policySold: item.policySold,
    actualEarning: item.actualEarning,
  }));

  useEffect(() => {
    const loggedInUser = secureStorage.getItem("authAgentUserInfo");
    if(loggedInUser.user_data.status === 1){
      setIsCreateAccess(true);
    }else{
      setIsCreateAccess(false);
    }
}, []) 

  return (  
    <React.Fragment>
       {isCountryId ? 
       <DashboardID/> 
       :
       <>
      <FullPageLoader show={loading} />
      <DashboardFilterPopup show={showFilterPopup} handleClose={handleFilterPopupClose} filterList={filterList.length ? filterList : []} filterType={filterType} onSuccess={(response: any) => {
        applyFilter(response.applied_filter);
      }}></DashboardFilterPopup>
      <div className="container-fluid">
        <div className="lead-top-heading p-lg-t">
          <h1>Dashboard</h1>
          <div className="right-sec-btn">
            <div className="search-bx">
              <div className="material" title="Search by anything">
                <input type="text" placeholder="Search by anything" value={searchKey} aria-label="Search text" onChange={(e) => setSearchKeyword(e.target.value)} onKeyDown={handleKeyDown}/>
                <i className="ic-search"></i>
              </div>
            </div>
            {
              isCreateAccess && 
              <Link to='/create-insurance-policy' className='m-sm-r'>
                <button className="btn-primary btn-width-auto">
                  <i className="ic-add"></i>
                  Create
                </button>
              </Link>
            }
            {/* onClick={showSuccessPopup} */}
            <Link to='/claim-list' className="btn-line btn-width-auto">
              <i className="ic-person"></i>
              Claim
            </Link>
          </div>
        </div>
        <div className="row p-lg-t">
          <div className="col-md-9 top-card-left">
            <div className="task-summery-outer bg-white top-card-radius">
              <div className="row">
                <div className="col-md-12">
                  <div className="summery-heading">
                    <h2>Task Summary</h2>
                    <div className="task-right-panel task-summery-left-panel">
                    
                      <fieldset className="single-select">
                        <div className="material" onClick={()=> handleFilterPopup(LEAD_LIST_FILTER.taskSummaryFilters, 'taskSummaryFilters')}>
                          <Select
                            value={selectedOption.taskSummaryFilters}
                            options={LEAD_LIST_FILTER.taskSummaryFilters}
                            placeholder="Till Today (All)"
                            className='react-select-opt custom-black-text'
                            classNamePrefix='react-select-opt'
                            isDisabled={true}
                          />
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div className='col-xs-4' onClick={() => handleRedirection(data?.bucket_data[0].type ?? '')}>
                  <div className='summery-card application-submit-card'>
                    <h3>{data?.bucket_data[0].count}</h3>
                    <span>{data?.bucket_data[0].screenTitle}</span>
                    <div className="next-arrow-bg">
                      <i className="ic-arrow_forward"></i>
                    </div>
                    <img src={CardIcn1} className="cardicn" />
                  </div>
                </div>
                <div className='col-xs-4' onClick={() => handleRedirection(data?.bucket_data[1].type ?? '')}>
                  <div className='summery-card policies-issued-card'>
                    <h3>{data?.bucket_data[1].count}</h3>
                    <span>{data?.bucket_data[1].screenTitle}</span>
                    <div className="next-arrow-bg">
                      <i className="ic-arrow_forward"></i>
                    </div>
                    <img src={CardIcn2} className="cardicn" />
                  </div>
                </div>
                <div className='col-xs-4' onClick={() => handleRedirection(data?.bucket_data[2].type ?? '')}>
                  <div className='summery-card pending-applications-card'>
                    <h3>{data?.bucket_data[2].count}</h3>
                    <span>{data?.bucket_data[2].screenTitle}</span>
                    <div className="next-arrow-bg">
                      <i className="ic-arrow_forward"></i>
                    </div>
                    <img src={CardIcn3} className="cardicn" />
                  </div>
                </div>
                
              </div>
            </div>
            <div className='task-summery-outer bg-white bottom-card-radius'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='earning-summery earning-summery-card'>
                    <h3>Earning Summary</h3>
                    <ul>
                      <li>
                        <img src={EarnIcn} alt="Earn Icon" />
                        <div className='earning-summery-txt'>
                          <label>{HELPER.addCurrencyFormatting(data?.earning_summary.comission_earned)}</label>
                          <span>Commission Earned</span>
                        </div>
                      </li>
                      <li>
                        <img src={PaidIcn} alt="Paid Icon" />
                        <div className='earning-summery-txt'>
                          <label>{HELPER.addCurrencyFormatting(data?.earning_summary.comisssion_paid)}</label>
                          <span>Commission Paid</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-3 top-card-right'>
            <div className="task-summery-outer bg-white">
              <div className="row">
                <div className="col-md-12 w-100">
                  <div className="summery-heading">
                    <h2>Task Summary</h2>
                    <div className="task-right-panel">
                      <fieldset className="single-select">
                        <div className="material" onClick={()=> handleFilterPopup(LEAD_LIST_FILTER.pendingPaymentFilters, 'pendingPaymentFilters')}>
                          <Select
                            value={selectedOption.pendingPaymentFilters}
                            options={LEAD_LIST_FILTER.pendingPaymentFilters}
                            placeholder="Till Today (All)"
                            className='react-select-opt custom-black-text'
                            classNamePrefix='react-select-opt'
                            isDisabled={true}
                          />
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-xs-6' onClick={() => handleRedirection(pendingPayment?.type ?? '')}>
                  <div className='summery-card pending-insurance-payments-card'>
                    <h3>{pendingPayment?.count}</h3>
                    <span>{pendingPayment?.screenTitle}</span>
                    <div className="next-arrow-bg">
                      <i className="ic-arrow_forward"></i>
                    </div>
                        <img src={CardIcn4} className="cardicn" />
                  </div>
                </div>
                <div className='col-12 col-xs-6'>
                  <div className='earning-summery pending-insurance-payment-card'>
                    <ul>
                      <li>
                        <img src={EarnIcn} alt="Earn Icon" className='web-view'/>
                        <div className='earning-summery-txt'>
                          <label>{HELPER.addCurrencyFormatting(pendingPayment?.pending_amount)}</label>
                          <span>{pendingPayment?.screenTitle}</span>
                          <div className="next-arrow-bg wap-view">
                            <i className="ic-arrow_forward"></i>
                          </div>
                           <img src={CardIcn1} className="cardicn"/>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 m-lg-t m-100'>
            <div className="task-summery-outer bg-white earning-compare-graph">
              <div className="row">
                <div className="col-md-12">
                  <div className="summery-heading">
                    <div>
                      <h2>Earning Comparison</h2>
                      <span className='graph-sub-heading'>Average Policy Sold: {graphData?.average_policy_sold}</span>
                      <span className='graph-sub-heading'>Average Actual Earning:  {HELPER.addCurrencyFormatting(graphData?.average_actual_earning)}</span>
                    </div>
                    <div className="task-right-panel">
                      <fieldset className="single-select">
                        <div className="material">
                          <Select
                            value={selectedOption.graphFilter}
                            onChange={handleGraphViewChange}
                            options={graphOption}
                            placeholder="View Type"
                            className='react-select-opt'
                            classNamePrefix='react-select-opt'
                          />
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div>
                    <VictoryChart width={800} height={300} domainPadding={{ x: 80 }} padding={{ top: 20, left: 40, right: 40, bottom: 100 }}>
                      <VictoryGroup offset={0} colorScale={["#EEF7FF", "#008CF0"]}>
                        {/* Policy Sold Bar */}
                        <VictoryBar
                          data={transformedData}
                          x="x"
                          y="policySold"
                          labels={({ datum }) => `Policy Sold: ${datum.policySold}\nActual Earning: ${HELPER.addCurrencyFormatting(datum.actualEarning.toFixed(2))}`}
                          labelComponent={<VictoryTooltip />}
                          style={{
                            data: {
                              fill: "#EEF7FF", // Bar color
                              strokeWidth: 2, // Border thickness
                            },
                          }}
                          // Adding cornerRadius to create rounded corners
                          cornerRadius={5} // Adjust this value for more or less rounding
                        />
                        
                        {/* Actual Earnings Bar */}
                        <VictoryBar
                          data={transformedData}
                          x="x"
                          y="actualEarning"
                          labels={({ datum }) => `Policy Sold: ${datum.policySold}\nActual Earning: ${HELPER.addCurrencyFormatting(datum.actualEarning.toFixed(2))}`}
                          labelComponent={<VictoryTooltip />}
                          style={{
                            data: {
                              fill: "#008CF0", // Bar color
                              strokeWidth: 2, // Border thickness
                            },
                          }}
                          // Adding cornerRadius to create rounded corners
                          cornerRadius={5} // Adjust this value for more or less rounding
                        />
                      </VictoryGroup>
                      
                      <VictoryAxis
                        tickFormat={(t) => {
                          // Check if t is a valid string in the format "Dec 2024"
                          if (typeof t === "string" && t.includes(" ")) {
                            const [month, year] = t.split(" "); // Split the combined string
                            return `${month}\n${year}`; // Display on two lines
                          }
                          return t; // Return the original value if it's not a string
                        }}
                        style={{
                          tickLabels: {
                            fontSize: 10, // Smaller font size
                            padding: 10,  // Space between labels and axis
                            textAnchor: "middle", // Center-align the text
                          },
                        }}
                      />
                      <VictoryLegend
                        x={50}
                        y={250}
                        orientation="horizontal"
                        gutter={15}
                        data={[
                          { name: "Policy Sold", symbol: { fill: "#EEF7FF", type: "square" } },
                          { name: "Actual Earning", symbol: { fill: "#008CF0", type: "square" } },
                        ]}
                        
                        style={{
                          labels: {
                            fontSize: 15,
                          },
                        }}
                        
                      />
                    </VictoryChart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-xs-12 m-lg-t'>
            <div className="task-summery-outer bg-white quick-support-outer">
              <div className="row">
                <div className="col-md-12 w-100">
                  <div className="summery-heading">
                    <h2>Quick Support</h2>
                  </div>
                  <div className='row'>
                    <div className='col-md-6 col-xs-6'>
                      <div className='quick-support-bg'>
                        <img src={CallIcn} alt="Call Icon" />
                        <label>Call Us</label>
                        <span>9 AM to 6 PM</span>
                        <a href={`tel:${masterConfig?.CALL_US}`} className='action-arrow'>
                            <i className='ic-keyboard_arrow_right'></i>
                        </a>
                      </div>
                    </div>
                    <div className='col-md-6 col-xs-6'>
                      <div className='quick-support-bg'>
                        <img src={MailIcn} alt="Mail Icon" />
                        <label>Write Us<br /> Mail</label>
                        <a href={`mailto:${masterConfig?.WRITE_US_MAIL}`} className='action-arrow'>
                            <i className='ic-keyboard_arrow_right'></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="model-outer upload-error-popup">
          <Modal show={error} handleClose={hideErrorPopup}>
            <div className="modal-body">
              <div className='upload-error-msg'>
                <img src={UploadError} alt="Upload Error" />
                <p>Some error found in uploaded image. Make sure document/photo should be correct</p>
                <span className='error-txt'> <i className='ic-clearclose'></i> Image size should be under 25 Mb</span>
                <span className='success-txt'> <i className='ic-check'></i> Image should not be blurry</span>
              </div>
            </div>
            <div className='modal-footer m-lg-t'>
              <button className='btn-primary btn-width-100'>Okay</button>
            </div>
          </Modal>
        </div>

        <div className="model-outer upload-success-popup">
          <Modal show={success} handleClose={hideSuccessPopup}>
            <div className="modal-body">
              <div className='upload-success-msg'>
                <div className='check-icn'>
                  <i className='ic-check'></i>
                </div>
                <span className='thanks-txt'>Thank You For Application Submission!</span>
                <div className='id-number'>Your application id is 1234567890</div>
              </div>
            </div>
            <div className='modal-footer m-lg-t'>
              <button className='btn-primary btn-white'>Okay</button>
            </div>
          </Modal>
        </div>
      </div>
      </>
      }
    </React.Fragment>
  );
};

interface ModalProps {
  handleClose: () => void;
  show: boolean;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ handleClose, show, children }) => {
  const showHideClassName = show ? 'modal display-block' : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className='modal-main'>
        {children}
        <button
          onClick={handleClose}
          className="close_icn"
        >
          <i className="ic-clearclose"></i>
        </button>
      </section>
    </div>
  );
};

export default Dashboard;
